import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 24, textAlign: 'center' }}>
                    <p>Произошла ошибка. Попробуйте перезапустить приложение.</p>
                    <button
                        type='button'
                        style={{
                            marginTop: 12,
                            padding: '8px 20px',
                            borderRadius: 8,
                            border: 'none',
                            background: '#1675e0',
                            color: '#fff',
                            cursor: 'pointer',
                        }}
                        onClick={() => window.location.reload()}
                    >
                        Перезагрузить
                    </button>
                    <button
                        type='button'
                        style={{
                            display: 'block',
                            margin: '12px auto 0',
                            padding: '8px 20px',
                            borderRadius: 8,
                            border: '1px solid #1675e0',
                            background: 'transparent',
                            color: '#1675e0',
                            cursor: 'pointer',
                        }}
                        onClick={() => window.history.back()}
                    >
                        Назад
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
